import React from "react";
import ReactDOM from "react-dom";
import {Container,Grid,Paper} from "@mui/material"
import '../style/style.css';
import unsplash from '../api/unsplash';
import { login,loginPersistant } from "../utils";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Homepage from "./Homepage";


const style =  {background: '#3b5998'};

class Login extends React.Component {


  constructor ()
  {
      super();

      this.state = {
        isChecked: false,
        passwordShown : false,
        icon:"bi bi-eye-slash-fill"
    };

  }
handleCheck = (e) =>{

this.setState({isChecked:e.target.checked});

  
}


componentDidMount = () => { //Coloro lo sfondo solo qui
    document.body.style.backgroundColor = "#2264ae";

}
handleEyeClick = () => {


this.setState({passwordShown:!this.state.passwordShown});

this.state.passwordShown ?this.setState({icon:"bi bi-eye-slash-fill"}): this.setState({icon:"bi bi-eye-fill"});


}

    handleLogin = async(event) => {

        event.preventDefault();
        var md5 = require("md5");
        console.log(md5(this.password.value));
        
        const response = await unsplash
        .post('login',{username :this.username.value,password:md5(this.password.value)} );
        //this.setState({images:response.data});
        if (response.data.utente.data.length > 0 ) {


           if(this.state.isChecked){ //per login dove si ricorda l'utente 
               loginPersistant(response.data.utente.token);
            }else{  
             
                login(response.data.utente.data[0].foto,response.data.utente.token);
            }
              
                
                this.props.navigate('/');
    
        }else {
           
            alert("USERNAME O PASSWORD ERRATE")
        }
    
    
    }



render(){
return (

  
<Container maxWidth="sm">
      <Grid
  container
  spacing={0}
  direction="column"
  alignItems="center"
  justifyContent="center"
  style={{ minHeight: '100vh'}}
>

<Grid
  container
  spacing={0}
  direction="column"
  alignItems="center"
  justifyContent="center"
  style={{ minHeight: '10vh' }}
>

<Paper elevation={3}  justifyContent="center" alignItems="center" style={{padding:"30px"}}> 
<img src={require("../assets/images/MILLERLogo-copia.jpg").default} className="img-fluid" alt=""/>


<form >
<div className="form-outline mb-4">
          <label className="form-label" htmlFor="username"  >Username</label>
            <input type="text" id="username" name="username" ref={username => (this.username = username)} className="form-control form-control-lg" />
          
          </div>
             
    <label className="form-label" htmlFor="password">Password</label>
          <div className="form-outline mb-4 input-group">
          
            <input type={this.state.passwordShown ? "text" : "password"} id="password" name="password" ref={password => (this.password = password)} className="form-control form-control-lg border-right-0" />
            <span className="input-group-text bg-transparent">
                <i className={this.state.icon} style={{cursor:"pointer"}} onClick={this.handleEyeClick}></i>
            </span>
          </div>

          <div className="d-flex justify-content-around align-items-center mb-4">

            <div className="form-check">
              <input onClick={this.handleCheck}
              ref={check => (this.check = check)}
                className="form-check-input"
                type="checkbox"
                name="check"
                value=""
                id="ricordami"
               
              />
              <label className="form-check-label" htmlFor="ricordami"> Ricordami </label>
            </div>
          </div>
          <button onClick={this.handleLogin} className="btn btn-primary btn-lg btn-block">Log in</button>
      </form>
  </Paper>
  </Grid>
</Grid> 
      </Container>



)


}



} 

 function WithNavigate(props) {
    const navigate = useNavigate();
  
    return <Login {...props} navigate={navigate} />;
  }

  export default WithNavigate



  /*
  
  <div>

<section className="vh-100 myCentered"> 
  <div className="container py-5 h-100">
    <div className="row d-flex align-items-center justify-content-center h-100">
      <div className="col-md-8 col-lg-7 col-xl-6">
        <img src={require("../assets/images/MILLERLogo.jpg").default} className="img-fluid" alt=""/>
      </div>
      <div className="col-md-7 col-lg-5 col-xl-5 offset-xl-1">
        <form>
          <div className="form-outline mb-4">
          <label className="form-label" htmlFor="username"  >Username</label>
            <input type="text" id="username" name="username" ref={username => (this.username = username)} className="form-control form-control-lg" />
          
          </div>
        
    <label className="form-label" htmlFor="password">Password</label>
          <div className="form-outline mb-4 input-group">
          
            <input type={this.state.passwordShown ? "text" : "password"} id="password" name="password" ref={password => (this.password = password)} className="form-control form-control-lg border-right-0" />
            <span className="input-group-text bg-transparent">
                <i className={this.state.icon} style={{cursor:"pointer"}} onClick={this.handleEyeClick}></i>
            </span>
          </div>

          <div className="d-flex justify-content-around align-items-center mb-4">

            <div className="form-check">
              <input onClick={this.handleCheck}
              ref={check => (this.check = check)}
                className="form-check-input"
                type="checkbox"
                name="check"
                value=""
                id="ricordami"
               
              />
              <label className="form-check-label" htmlFor="ricordami"> Ricordami </label>
            </div>
          </div>
          <button onClick={this.handleLogin} className="btn btn-primary btn-lg btn-block">Log in</button>

        </form>
      </div>
    </div>
  </div>
</section> 

</div>


  */